import type {ConnectElementConfig} from '../../../connect/ConnectJSInterface/ConnectElementList';
import {ComponentOverrideFlag} from '../../../utils/flags/flags';

export const CapitalOverviewConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "capitalOverviewExperience" */
      '../../../components/Capital/CapitalOverview'
    ),
  enabledOverrideFlag: ComponentOverrideFlag.capital_overview,
  releaseState: 'preview',
  sentryTeam: 'capital_core_products',
  teamOwner: 'capital-core-products',
  description:
    'Serves as a mini Capital dashboard that allows the user to access their current and past Capital loan information at all times.',
  friendlyName: 'Capital overview',
  deprecated: {
    // Note: there is no platform usage for this component, so there's no need to give an alternative
    deprecatedMessage: 'The capital overview component is deprecated.',
  },
};
